export const allowedFileTypesForInlineFeedback = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
export const honorCodeLink = 'https://learner.coursera.help/hc/articles/209818863';

export default {
  allowedFileTypesForInlineFeedback,
  honorCodeLink,
};
